import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from "../index";
import { fetchUser, fetchUsers, updateUser } from "../../actions/callrecorder/usersActions";
import { fetchUserNumber, fetchUserNumbers } from "../../actions/callrecorder/userNumbersActions";

export interface UserNumberCapabilitiesInterface {
  sms_incoming: boolean;
  sms_outgoing: boolean;
  call_incoming: boolean;
  call_outgoing: boolean;
  domestic_sms_only: boolean;
  domestic_call_only: boolean;
}

export interface UserNumberInterface {
  url: string;

  id: number;
  user_id: number;
  number: string;
  number_type: string;
  friendly_name: string | null;

  active: boolean;
  sms_verified: boolean;
  call_verified: boolean;
  premium: boolean;

  unread_sms_count: number;
  incoming_sms_count: number;
  total_incoming_sms_limit: number;
  extra_incoming_sms_count: number;
  subscription_status: string | null;
  capabilities: UserNumberCapabilitiesInterface;

  virtual_number_id: number | null;
  phone_number_id: number | null;
  state_id: number | null;

  created_at: string;
  updated_at: string;
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,
};

const adaptor = createEntityAdapter<UserNumberInterface>();

const slice = createSlice({
  name: 'userNumbers',
  initialState: adaptor.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    builder
      // #index
      .addCase(fetchUserNumbers.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchUserNumbers.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.userNumbers;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchUserNumbers.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      // #show
      .addCase(fetchUserNumber.fulfilled, (state, action) => {
        const userNumber = Object.values(action.payload.userNumber)[0];
        state.entities[userNumber.id] = userNumber;
      })

      // #users — merge user_numbers extracted from user responses
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.entities = { ...state.entities, ...action.payload.userNumbers };
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.entities = { ...state.entities, ...action.payload.userNumber };
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.entities = { ...state.entities, ...action.payload.userNumber };
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  selectById: selectUserNumberById,
  selectIds: selectUserNumberIds,
  selectEntities: selectUserNumberEntities,
} = adaptor.getSelectors<RootState>(state => state.callrecorder.userNumbers);
